import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, refresh } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated === null) {
      refresh();
      return;
    }
    if (isAuthenticated === false) {
      navigate("/login", { replace: true, state: { from: location.pathname } });
    }
  }, [isAuthenticated, location.pathname, navigate, refresh]);

  if (isAuthenticated === null) {
    return (
      <div data-testid="auth-check-loading" className="min-h-screen bg-slate-950 text-slate-100 flex items-center justify-center">
        <div className="text-sm text-slate-400" data-testid="auth-check-loading-text">Checking session…</div>
      </div>
    );
  }

  if (isAuthenticated === false) return null;

  return <div data-testid="protected-route-container">{children}</div>;
}
